module.exports = __webpack_public_path__ + "img/w9-b3.1c03b7fb.jpg";